// Copyright (c) 2016 Deere & Company

import Modal, {getDefaultState} from '../../shared/state/modal';
import actions from '../../actions-list';

const updateStatusChangeModalVisibility = (state, action) =>
    Modal.update(state, {
        [action.propertyToUpdate]: {
            $set: action.value
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_PRODUCT_SEARCH_STATUS_CHANGE_MODAL_VISIBILITY]: updateStatusChangeModalVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/search/reducers/status-change-modal-visibility.js